import axios from "axios";
import { authHeaders } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const cfg = () => ({ headers: authHeaders(), withCredentials: true });

export const api = {
  get: (path) => axios.get(`${API}${path}`, cfg()).then((r) => r.data),
  post: (path, body) => axios.post(`${API}${path}`, body, cfg()).then((r) => r.data),
  put: (path, body) => axios.put(`${API}${path}`, body, cfg()).then((r) => r.data),
  del: (path) => axios.delete(`${API}${path}`, cfg()).then((r) => r.data),
  upload: (path, file) => {
    const form = new FormData();
    form.append("file", file);
    return axios.post(`${API}${path}`, form, { headers: authHeaders(), withCredentials: true }).then((r) => r.data);
  },
};

export const fileUrl = (path) => `${API}${path}`;

export const errorMessage = (err, fallback = "Something went wrong. Please try again.") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return fallback;
};
